import { render, staticRenderFns } from "./PerformanceCliente.vue?vue&type=template&id=205f05b0"
import script from "./PerformanceCliente.vue?vue&type=script&lang=js"
export * from "./PerformanceCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports